var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentsFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(255,255,255,0.5);opacity:0;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-78 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(78 228)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 200.061)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.675,35.744H17.419a7.8,7.8,0,0,0-14.383,0H1.8a1.8,1.8,0,0,0-1.8,1.8v2.4a1.8,1.8,0,0,0,1.8,1.8H4.263l-.258-.787a6.607,6.607,0,1,1,12.456-4.414l.005.013a5.2,5.2,0,0,1,.281,1.1,6.6,6.6,0,0,1-.3,3.288l0,.007a6.585,6.585,0,0,1-6.2,4.4,1.8,1.8,0,1,0,1.788,1.8v-.809a7.788,7.788,0,0,0,5.374-4.59h1.264a1.8,1.8,0,0,0,1.8-1.8v-2.4A1.8,1.8,0,0,0,18.675,35.744Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M121,100.657v1.2h5.4a5.4,5.4,0,1,0-4.246-2.064,1.193,1.193,0,0,1-1.153.864Zm7.2-4.8h1.2v1.2h-1.2Zm-2.4,0H127v1.2h-1.2Zm-2.4,0h1.2v1.2h-1.2Z",
    transform: "translate(-116.161 -57.715)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentsFill);
export default __webpack_public_path__ + "static/media/agentsFill.e4a162c970593f5bf283a831b76037f9.svg";
export { ForwardRef as ReactComponent };